import { useTranslation } from 'react-i18next';

const brands = [
  { name: 'Acuity Brands', src: 'https://www.kitokogroup.com/wp-content/uploads/2021/02/Acuity-K-Logolar-150x150.png' },
  { name: 'AEC', src: 'https://www.kitokogroup.com/wp-content/uploads/2021/02/AEC-K-Logolar-03-150x150.png' },
  { name: 'Ares', src: 'https://www.kitokogroup.com/wp-content/uploads/2021/02/ares-K-Logolar-06-150x150.png' },
  { name: 'DeltaLight', src: 'https://www.kitokogroup.com/wp-content/uploads/2020/12/deltalightK-Logolar-17-150x150.png' },
  { name: 'DGA', src: 'https://www.kitokogroup.com/wp-content/uploads/2020/12/dgaK-Logolar-18-150x150.png' },
  { name: 'Disano', src: 'https://www.kitokogroup.com/wp-content/uploads/2020/12/disano-K-Logolar-19-150x150.png' },
  { name: 'Element4', src: 'https://www.kitokogroup.com/wp-content/uploads/2020/12/e4-K-Logolar-22-150x150.png' },
  { name: 'Flos', src: 'https://www.kitokogroup.com/wp-content/uploads/2021/01/flos-K-Logolar-30-150x150.png' },
  { name: 'GVA', src: 'https://www.kitokogroup.com/wp-content/uploads/2021/01/gva-K-Logolar-32-150x150.png' },
  { name: 'Hess', src: 'https://www.kitokogroup.com/wp-content/uploads/2021/01/hess-K-Logolar-33-150x150.png' },
  { name: 'iGuzzini', src: 'https://www.kitokogroup.com/wp-content/uploads/2021/01/iguzzini-K-Logolar-34-150x150.png' },
  { name: 'KKDC', src: 'https://www.kitokogroup.com/wp-content/uploads/2021/01/kkdc-K-Logolar-36-150x150.png' },
  { name: 'Luce & Light', src: 'https://www.kitokogroup.com/wp-content/uploads/2021/01/LL-K-Logolar-43-150x150.png' },
  { name: 'Nemo', src: 'https://www.kitokogroup.com/wp-content/uploads/2021/01/nemo-K-Logolar-49-150x150.png' },
  { name: 'Osram', src: 'https://www.kitokogroup.com/wp-content/uploads/2021/01/osram-K-Logolar-54-150x150.png' },
  { name: 'Pharos', src: 'https://www.kitokogroup.com/wp-content/uploads/2021/01/pharos-K-Logolar-58-150x150.png' },
  { name: 'Prolicht', src: 'https://www.kitokogroup.com/wp-content/uploads/2021/01/prolight-K-Logolar-59-150x150.png' },
  { name: 'Schreder', src: 'https://www.kitokogroup.com/wp-content/uploads/2021/01/schreder-K-Logolar-66-150x150.png' },
  { name: 'Siteco', src: 'https://www.kitokogroup.com/wp-content/uploads/2021/01/siteco-K-Logolar-67-150x150.png' },
  { name: 'Traxon', src: 'https://www.kitokogroup.com/wp-content/uploads/2021/01/traxon-K-Logolar-71-150x150.png' },
];

export default function Brands() {
  const { t } = useTranslation();

  return (
    <section id="brands" className="bg-white py-24 px-6 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-amber-50 border border-amber-200 rounded-full px-4 py-1.5 mb-6">
            <span className="w-1 h-1 bg-amber-500 rounded-full" />
            <span className="text-amber-600 text-xs tracking-[0.2em] uppercase font-semibold" style={{ fontFamily: "'Montserrat', sans-serif" }}>{t('brands.badge')}</span>
          </div>
          <h2 className="text-gray-900 text-3xl md:text-4xl font-bold leading-tight" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            {t('brands.heading')} <span className="text-amber-500">{t('brands.headingAccent')}</span>
          </h2>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-x-6 gap-y-10">
          {brands.map((brand, idx) => (
            <div key={idx} className="group flex items-center justify-center bg-gray-50 hover:bg-white border border-gray-100 hover:border-amber-200 rounded-xl p-6 transition-all duration-300" style={{ boxShadow: '0 1px 4px rgba(0,0,0,0.04)' }}>
              <img src={brand.src} alt={brand.name} className="max-w-[160px] max-h-[80px] w-auto h-auto object-contain grayscale opacity-70 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-300" loading="lazy" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}